import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const UserStrategy = {
  namespaced: true,
  state: {
    userStrategies: [],
    comparisonIds: [],
    validationProperties: {},
  },
  getters,
  mutations,
  actions
};

